import * as React from 'react';
import { Link } from "office-ui-fabric-react";
import { TaskCalculationModeTypes } from '../../../components/views/list/columns/task/Mode';
import { SettingDropdown, SettingDropdownOption } from './SettingDropdown';

const options: SettingDropdownOption[] = [
    {
        key: TaskCalculationModeTypes.Auto,
        text: TaskCalculationModeTypes.Auto,
        description: <>Horizontal and vertical (roll-up) calculation for progress-related fields is performed automatically.</>
    },
    {
        key: TaskCalculationModeTypes.Manual,
        text: TaskCalculationModeTypes.Manual,
        description: <>Horizontal and vertical (roll-up) calculation for progress-related fields is performed on-demand.</>
    }
];

export const NewPpmxTasksCalculationModeSection = (props: {
    readonly?: boolean,
    value?: boolean,
    onChange: (value: boolean) => void
}) => {
    return <div className="project-calculation-mode">
        <SettingDropdown
            label="Mode"
            required
            info={<>Select default mode for new Tasks in PPM Express schedule.
                Please refer to <Link href='https://help.ppm.express/94162-portfolio-and-project-management/2082039-project-settings#section-6' target='_blank'>this article</Link> for more details.</>}
            selectedKey={props.value ? TaskCalculationModeTypes.Auto : TaskCalculationModeTypes.Manual}
            options={options}
            disabled={props.readonly}
            onChange={key => props.onChange(key === TaskCalculationModeTypes.Auto)} />
    </div>;
}
